module.exports = __webpack_public_path__ + "static/img/tc1.49f4908.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/tc1.png
// module id = b5+4
// module chunks = 1